import Select from 'tether-select-nobower';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';

export default class extends Select {
  constructor({ el }) {
    super({
      el,
      alignToHighlighted: 'never',
      className: 'Header__aisle-list',
    });

    this.on('change', this._onDropdownChange.bind(this));
    this.on('open', this._onDropdownOpen.bind(this));
    this.on('close', this._onDropdownClose.bind(this));
    // Nesting the dropdown element to add Legacy Scope
    $(this.drop).wrap("<div class='non-legacy'></div>");
  }

  _onDropdownChange() {
    const $select = $(this.select);
    var selectedItem = $select.find('li.select-option.select-option-selected').data('value');
    if (selectedItem && selectedItem !== this.select.value) {
      $select
        .find('option')
        .removeAttr('selected')
        .filter('[value="' + selectedItem + '"]')
        .attr('selected', 'selected');
      this.update();
    }
  }

  _onDropdownOpen() {
    SharedDispatcher.trigger('overlay:show', { cssModifier: 'header', noSpinner: true });
  }

  _onDropdownClose() {
    SharedDispatcher.trigger('overlay:hide');
  }
}
